module.exports = __webpack_public_path__ + "img/money-big.487a9f57.png";